var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshSquare2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49935 18.3334H12.4993C16.666 18.3334 18.3327 16.6667 18.3327 12.5001V7.50006C18.3327 3.33339 16.666 1.66673 12.4993 1.66673H7.49935C3.33268 1.66673 1.66602 3.33339 1.66602 7.50006V12.5001C1.66602 16.6667 3.33268 18.3334 7.49935 18.3334Z",
    stroke: "#F79009",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5846 10.0001C14.5846 12.5334 12.5346 14.5834 10.0013 14.5834C7.46797 14.5834 5.92629 12.0334 5.92629 12.0334M5.92629 12.0334H7.99297M5.92629 12.0334V14.3251M5.41797 10.0001C5.41797 7.46673 7.4513 5.41673 10.0013 5.41673C13.0596 5.41673 14.5846 7.96673 14.5846 7.96673M14.5846 7.96673V5.67506M14.5846 7.96673H12.5513",
    stroke: "#F79009",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshSquare2);
export default __webpack_public_path__ + "static/media/refresh-square-2.98f7b9aa47ac3cdda0c5da0a17e702fb.svg";
export { ForwardRef as ReactComponent };